import {
  Box,
  Button,
  Modal,
  Slide,
  Typography,
  Stack,
  Avatar,
  SxProps,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useEffect, useState } from 'react';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
import ImageWrapper from '../../elements/ImageWrapper';
const styles: IStyles = {
  root: {},

  containerBox: {
    border: '1px solid #C9E5D7',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    // padding: '8px 16px',
    padding: { xs: pxToRem(6), md: pxTovW(9) },
    gap: 1,
    backgroundColor: '#F9FFFB',
    width: { sm: pxToRem(220), md: pxTovW(250) },
    // height: { sm: pxToRem(70), md: pxTovW(68) },
  },
  iconContainer: {
    backgroundColor: '#E3F8EC',
    paddingX: { xs: pxToRem(10), md: pxTovW(10) },
    paddingY: { xs: pxToRem(5), md: pxTovW(5) },
    marginRight: { xs: pxToRem(5), md: pxTovW(8) },
    borderRadius: { xs: pxToRem(5), md: pxTovW(5) },
  },
  iconwarp: {
    width: { sm: pxToRem(25), md: pxToRem(20), desktop: pxTovW(30) },
    height: { sm: pxToRem(40), md: pxToRem(35), desktop: pxTovW(45) },
    borderRadius: pxToRem(5),
    margin: 'auto',
  },
  lables: {
    fontSize: { sm: pxToRem(20), md: pxTovW(22) },
    fontWeight: 'bold',
  },
};
export type ConductionMode = 'Geneo App' | 'Geneo Clicker' | 'OMR Test';
export type CondutionValueType = 'mobile-app' | 'clicker' | 'omr';
interface BtnIcon {
  id: CondutionValueType;
  image: CondutionValueType;
  label: ConductionMode;
}

const btnIcons: BtnIcon[] = [
  {
    id: 'mobile-app',
    image: 'mobile-app', //icon name
    label: 'Geneo App',
  },
  {
    id: 'clicker',
    image: 'clicker', //icon name
    label: 'Geneo Clicker',
  },
  {
    id: 'omr',
    image: 'omr',
    label: 'OMR Test',
  },
];
interface ConductionButtonsProps {
  value: CondutionValueType;
  onChange: (value: CondutionValueType) => void;
  customCSS?: SxProps;
  direction?: 'row' | 'column'; // 👈 new prop
  isOMREnabled?: boolean;
  isClickerEnabled?: boolean;
}
export const ConductionButtonsComponent = ({
  value,
  onChange,
  customCSS,
  direction,
  isOMREnabled,
  isClickerEnabled,
}: ConductionButtonsProps) => {
  // const [selected, setSelected] = useState<CondutionValueType>(value);

  const selectOption = (val: CondutionValueType) => {
    onChange(val);
    // setSelected(val);
  };

  return (
    <Box
      sx={{
        // maxWidth: { lg: pxTovW(650) },
        minWidth: pxToRem(200),
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        alignItems: 'flex-start',
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontWeight: 'bold',
          marginBottom: pxToRem(20),
        }}
      >
        Choose Mode of Conduction
      </Typography>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          paddingBottom: { xs: pxToRem(10), md: pxTovW(10) },
        }}
      >
        <Stack
          // direction={direction || { xs: 'column', md: 'row' }} // 👈 dynamic direction
          direction="row"
          // flexWrap={{ xs: 'wrap' }} // optional: allows wrap in small screens
          // justifyContent={{ xs: 'center', md: 'flex-start' }}
          // alignItems="center"
          // spacing={{ xs: 2, md: 1 }}
          // useFlexGap
          flexWrap="wrap"
          useFlexGap
          gap={{ xs: 2, md: 2 }}
          sx={{
            // maxWidth: '100%',
            // width: { xs: '100%', sm: 'auto' },
            width: '100%',
            maxWidth: '100%',
            justifyContent: {
              xs: 'flex-start',
              md: 'center',
            },
            alignItems: 'flex-start',
            ...customCSS,
          }}
        >
          {/* Geneo App Option */}
          {btnIcons
            .filter((item) => {
              if (item.id === 'clicker') return Boolean(isClickerEnabled);
              if (item.id === 'omr') return Boolean(isOMREnabled);
              return true;
            })
            .map((item) => (
              <Box
                sx={{
                  display: 'flex',
                  // flexDirection: 'row',
                  alignItems: 'center',
                  cursor: 'pointer',
                  // minWidth: { xs: '140px', sm: '180px' },
                  // flexShrink: 0,
                  // width: { xs: '140px', sm: '180px' },
                  // maxWidth: '260px',
                  // flex: 1,
                  width: {
                    xs: '100%',
                    md: pxTovW(300), // or '260px'
                  },
                  flexShrink: 0,
                }}
                onClick={() => selectOption(item.id)}
              >
                <Box sx={{ width: '30px' }}>
                  <CheckCircleIcon
                    sx={{
                      color: '#00C853',
                      display: item.id === value ? 'inline-flex' : 'none',
                    }}
                    fontSize="small"
                  />
                </Box>

                <Box sx={styles.containerBox}>
                  <Box sx={styles.iconContainer}>
                    <ImageWrapper
                      name={item.image}
                      type="png"
                      parentFolder="icons"
                      styles={styles.iconwarp}
                    />
                  </Box>
                  <Typography sx={styles.lables}> {item.label}</Typography>
                </Box>
              </Box>
            ))}
        </Stack>
      </Box>
    </Box>
  );
};
